import React, { useState, useMemo } from 'react';
import { Header } from '../common_v2/components/Header';
import { Footer } from '../common_v2/components/Footer';
import { Panel, PanelBorderRadius, PanelBorderStyle, PanelTheme, ShowIf } from '@apply/components';
import { PaymentInfo } from './components/PaymentInfo/PaymentInfo';
import { CheckoutForm } from './components/CheckoutForm/CheckoutForm';
import { v4 as uuidv4 } from 'uuid';
import { isMobileScreen } from '@apply/ui';
import {
    useCustomPaymentAddressState,
    useCustomPaymentIsPropertyInArizona,
    useCustomPaymentPurpose,
} from './fields/CustomPaymentFields';
import { CustomPaymentStep } from './constants/CustomPaymentStep';
import { FinishedPanel } from './components/FinishedPanel/FinishedPanel';

export const CustomPayment: React.FC = () => {
    const mobileScreen = isMobileScreen();
    const [paymentStep, set_paymentStep] = useState<CustomPaymentStep>(CustomPaymentStep.PaymentInfo);

    const customPaymentGuid = useMemo(() => uuidv4(), []);

    const [state] = useCustomPaymentAddressState(customPaymentGuid);
    const [isPropertyInArizona] = useCustomPaymentIsPropertyInArizona(customPaymentGuid);
    const [paymentPurpose] = useCustomPaymentPurpose(customPaymentGuid);

    const isNextDisabled =
        state === 'AZ' &&
        Boolean(isPropertyInArizona) &&
        ['Appraisal + Underwriting Fee', 'Appraisal', 'Underwriting Fee'].includes(paymentPurpose ?? '');

    return (
        <>
            <div className='app-container'>
                <Header
                    printMode={true}
                    showLogo={true}
                />
                <main>
                    <div className={`customPayment ${mobileScreen ? 'mobile' : ''}`}>
                        <h2>Builder Finance Inc. Payments</h2>
                        <br />
                        <Panel
                            theme={PanelTheme.White}
                            borderRadius={PanelBorderRadius.Medium}
                            borderStyle={PanelBorderStyle.None}
                        >
                            <ShowIf showIf={paymentStep == CustomPaymentStep.PaymentInfo}>
                                <PaymentInfo
                                    customPaymentGuid={customPaymentGuid}
                                    nextDisabled={isNextDisabled}
                                    set_paymentStep={set_paymentStep}
                                />
                            </ShowIf>
                            <ShowIf showIf={paymentStep == CustomPaymentStep.Checkout}>
                                <CheckoutForm
                                    customPaymentGuid={customPaymentGuid}
                                    set_paymentStep={set_paymentStep}
                                />
                            </ShowIf>
                            <ShowIf showIf={paymentStep == CustomPaymentStep.Finished}>
                                <FinishedPanel />
                            </ShowIf>
                        </Panel>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
};
